import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/layout/HomePageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PRFaq"] */ "/opt/build/repo/src/components/portfolio-review/PRFaq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PRSampleScorecard"] */ "/opt/build/repo/src/components/portfolio-review/PRSampleScorecard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PRTestimonialsMarquee"] */ "/opt/build/repo/src/components/portfolio-review/PRTestimonialsMarquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PRWhyTrust"] */ "/opt/build/repo/src/components/portfolio-review/PRWhyTrust.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/portfolio-review/Reveal.tsx");
